<template>
  <v-text-field
    v-model="model"
    class="mb-2"
    :label="computedLabel"
    :rules="rules"
    :counter="counter"
    clearable
    density="compact"
    variant="outlined"
  />
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'InputField',
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    counter: { type: Number },
    rules: {
      type: Array as PropType<((v: string) => true | string)[]>,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isRequired = computed(() => {
      return props.rules.some((rule) => typeof rule('') === 'string')
    })

    const computedLabel = computed(() => {
      return isRequired.value ? `${props.label} *` : props.label
    })

    const model = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    })
    return { model, computedLabel }
  },
})
</script>


<style scoped>
:deep(.v-input__details) {
  padding-top: 4px !important;
  align-items: flex-start;
}
</style>
